import { useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";
import {
  allPricelistButtonStyle,
  allPricelistCardContentStyle,
  allPricelistCardNameStyle,
  allPricelistCardStyle,
  allPricelistGridStyle,
  allPricelistTitleBoxStyle,
  allPricelistWrapperStyle,
  circularProgressStyle,
  loaderContainerStyle,
  pricelistCardImageStyle,
  pricelistCardOverlayStyle,
  pricelistCardServicesStyle,
  pricelistTitleText,
  textField,
  noAllPricelistBoxStyle,
  noResultTextStyle,
  noResultDescriptionStyle,
  requestPricelistButtonStyle,
} from "../../styles/styles";

const AllPricelistsSection = (props) => {
  const {
    handleManageClick,
    getAllPricelistsData,
    searchTerm,
    setSearchTerm,
    allPricelistsData,
    allPricelistsLoader,
    handleRequestPricelist,
  } = props;
  const { t } = useTranslation(["pricelist-search", "categories"]);

  useEffect(() => {
    if (searchTerm === "") {
      getAllPricelistsData();
      return;
    }

    const debounceTimeout = setTimeout(() => {
      getAllPricelistsData();
    }, 500);

    return () => clearTimeout(debounceTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  return (
    <Box sx={allPricelistWrapperStyle}>
      <Box sx={allPricelistTitleBoxStyle}>
        <Typography sx={{ ...pricelistTitleText, whiteSpace: "nowrap" }}>
          {t("all_pricelist")}
        </Typography>

        <Box>
          <TextField
            value={searchTerm}
            onChange={(e) => {
              const value = e.target.value;
              setSearchTerm(value);
            }}
            variant="outlined"
            placeholder={t("find_pricelist")}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setSearchTerm("");
                    }}
                    size="small"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={textField}
          />
        </Box>
      </Box>

      <Box sx={{ flex: 1 }}>
        {allPricelistsLoader ? (
          <Box sx={loaderContainerStyle}>
            <CircularProgress size={60} sx={circularProgressStyle} />
          </Box>
        ) : allPricelistsData.length > 0 ? (
          <Box sx={allPricelistGridStyle}>
            {allPricelistsData.map((item) => (
              <Card sx={allPricelistCardStyle}>
                <Box
                  sx={{
                    ...pricelistCardImageStyle,
                    height: "156px",
                  }}
                >
                  <img
                    width="100%"
                    height="100%"
                    src={item.image_url}
                    alt={item.subcategory_name}
                    style={{ objectFit: "cover" }}
                  />

                  {/* overlay */}
                  <Box sx={pricelistCardOverlayStyle} />
                </Box>
                <Box sx={allPricelistCardContentStyle}>
                  <Typography sx={allPricelistCardNameStyle}>
                    {t(item.subcategory_name, { ns: "categories" })}
                  </Typography>

                  <Typography sx={pricelistCardServicesStyle}>
                    {item.total_variants} {t("services")}
                  </Typography>

                  <Button
                    variant="contained"
                    onClick={() => handleManageClick(item.subcategory_id)}
                    sx={allPricelistButtonStyle}
                  >
                    {t("add_pricelist")}
                  </Button>
                </Box>
              </Card>
            ))}
          </Box>
        ) : (
          searchTerm && (
            <Box sx={noAllPricelistBoxStyle}>
              <Box display="flex">
                <img
                  src="/icons/eyes-look-left-icon.svg"
                  alt="eyes-look-left-icon"
                  width="48px"
                  height="48px"
                />
              </Box>
              <Typography sx={noResultTextStyle}>{t("no_result")}</Typography>
              <Typography sx={noResultDescriptionStyle}>
                {t("no_result_description")}
              </Typography>
              <Typography
                sx={{ ...noResultDescriptionStyle, fontWeight: 500, mt: "0px" }}
              >
                {t("no_result_description_2")}
              </Typography>

              <Button
                variant="contained"
                onClick={() => {
                  handleRequestPricelist();
                }}
                sx={requestPricelistButtonStyle}
              >
                {t("request_pricelist_button", { searchTerm })}
              </Button>
            </Box>
          )
        )}
      </Box>
    </Box>
  );
};

export default AllPricelistsSection;
